export enum ViewType {
    Picker,
    Numpad,
}
